import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../config";
import { useReactToPrint } from "react-to-print";
import handleValidDate from "../../helpers/utils/handleValidDate";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../store/app/action";
import { resetDepartmentState, getDepartment } from "../../store/department/action";
import { resetVendorState, getVendor } from "../../store/vendor/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../store/paymentMethod/action";
import { resetPaymentTermState, getPaymentTerm, addNewPaymentTerm } from "../../store/paymentTerm/action";
import { resetShipmentMethodState, getShipmentMethod, addNewShipmentMethod } from "../../store/shipmentMethod/action";
import { resetShipmentCarrierState, getShipmentCarrier, addNewShipmentCarrier } from "../../store/shipmentCarrier/action";
import { resetProductVarianState, getProductVarian } from "../../store/productVarian/action";
import { resetTransactionTaxState, getTransactionTax } from "../../store/transactionTax/action";
import { getAccAccount, resetAccAccountState } from "../../store/accAccount/action";
import { resetPurchaseState, getPurchase as onGetPurchases, addNewPurchase as onAddNewPurchase, updatePurchase as onUpdatePurchase, deletePurchase as onDeletePurchase, getPurchaseLoading, resetPurchaseCreateState } from "../../store/purchase/action";

import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";

import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../Components/ModalInputFile";
import defaultImg from "../../assets/images/upload.png";
import PrintDoc from "./PrintDoc";
import ExportDoc from "../../Components/Common/ExportDoc";

const Purchase = () => {
  const printRef = useRef(null);
  const [pageIdx, setPageIdx] = useState(0);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [submitType, setSubmitType] = useState("");

  const dispatch = useDispatch();
  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    clients,
    clientLoading,
    purchases,
    purchaseAdded,
    isPurchaseCreated,
    isPurchaseSuccess,
    loading,
    error,
    paymentMethods,
    paymentMethodLoading,
    paymentTerms,
    paymentTermLoading,
    companies,
    companyLoading,
    departments,
    departmentLoading,
    vendors,
    vendorLoading,
    shipmentMethods,
    shipmentMethodLoading,
    shipmentCarriers,
    shipmentCarrierLoading,
    branches,
    branchLoading,
    transactionTaxs,
    transactionTaxLoading,
    productVarians,
    productVarianLoading,
    accAccounts,
    accAccountLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    purchaseAdded: state.Purchase.purchaseAdded,
    purchases: state.Purchase.purchases,
    isPurchaseCreated: state.Purchase.isPurchaseCreated,
    isPurchaseSuccess: state.Purchase.isPurchaseSuccess,
    loading: state.Purchase.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    paymentTerms: state.PaymentTerm.paymentTerms,
    paymentTermLoading: state.PaymentTerm.loading,
    shipmentMethods: state.ShipmentMethod.shipmentMethods,
    shipmentMethodLoading: state.ShipmentMethod.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    vendors: state.Vendor.vendors,
    vendorLoading: state.Vendor.loading,
    shipmentCarriers: state.ShipmentCarrier.shipmentCarriers,
    shipmentCarrierLoading: state.ShipmentCarrier.loading,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    transactionTaxLoading: state.TransactionTax.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Purchase.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
  }));

  const [purchaseList, setPurchaseList] = useState([]);
  const [purchaseDoc, setPurchaseDoc] = useState([]);
  const [purchase, setPurchase] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusPurchase, setStatusPurchase] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [paymentTermList, setPaymentTermList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [shipmentMethodList, setShipmentMethodList] = useState([]);
  const [shipmentCarrierList, setShipmentCarrierList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [materialList, setMaterialList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [modalMedia, setModalMedia] = useState(false);
  const [purDocImg, setPurDocImg] = useState([]);

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const [branchIdSelected, setBranchIdSelected] = useState(null);
  const [departmentSelect, setDepartmentSelect] = useState(null);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPurchases = purchases;
      if (type !== "all") {
        filteredPurchases = purchases.filter((purchase) => purchase.purchase_status.name === type);
      }
      setPurchaseList(filteredPurchases);
    }
  };

  // useEffect(() => {
  //   setPurchaseList(purchases);
  // }, [purchases]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "dueat",
        label: "Jatuh Tempo",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_detail",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total",
        isSelected: true,
        data: [],
      },
      {
        id: "down_payment",
        label: "Uang Muka",
        isSelected: true,
        data: [],
      },
      {
        id: "paid_amount",
        label: "Total Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_status",
        label: "Status",
        isSelected: true,
        data: [],
      },
    ];

    if (purchaseList.length > 0) {
      purchaseList.forEach((purchase) => {
        if (purchase.isChecked) {
          Object.entries(purchase).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "transactionat" || doc.id === "dueat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "purchase_detail") {
                let qty = 0;
                value.forEach((element) => {
                  qty += parseFloat(element.quantity);
                });
                doc.data.push(currencyFormat(qty));
              } else if (doc.id === "total_amount" || doc.id === "down_payment" || doc.id === "paid_amount") {
                doc.data.push(currencyFormat(value === null ? 0 : value));
              } else if (doc.id === "purchase_status") {
                doc.data.push(`${value && value.name} - ${purchase.hasPaid ? "PAID" : "UNPAID"}`);
              } else {
                doc.data.push(value);
              }
            }
          });
        }
      });
    }

    setPurchaseDoc(dataDoc);
  }, [purchaseList]);

  useEffect(() => {
    if (branchSelected && companySelected) {
      setDepartmentSelect({
        label: userData?.user?.user_department?.name,
        value: userData?.user?.user_department?.id,
      });
      setBranchIdSelected(branchSelected?.value ?? "");
      handleGetPurchase(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  const handleGetPurchase = (id, branchId) => {
    dispatch(resetPurchaseState());
    dispatch(onGetPurchases({ companyId: id, typeId: 2, branchId: branchId }));

    handleGetVendor(id);
    handleGetDepartement(id);
    handleGetProductVariant(id);
    handleGetPaymentTerm(id);
    handleGetPaymentMethod(id, branchId);
    handleGetTransactionTax(id);
    handleGetShipmentCarrier(id);
    handleGetShipmentMethod(id);
    handleGetAccAccount(id);
  };

  const handleGetPaymentTerm = (id) => {
    dispatch(resetPaymentTermState());
    dispatch(getPaymentTerm({ companyId: id, status: 2, type: "Purchase" }));
  };

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, branchId: branchId, status: 2, type: "Purchase" }));
  };

  const handleGetShipmentCarrier = (companyId) => {
    dispatch(resetShipmentCarrierState());
    dispatch(getShipmentCarrier({ companyId: companyId, status: 2, type: "Purchase" }));
  };

  const handleGetShipmentMethod = (companyId) => {
    dispatch(resetShipmentMethodState());
    dispatch(getShipmentMethod({ companyId: companyId, status: 2, type: "Purchase" }));
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetVendor = (companyId) => {
    //{ companyId: companyId }
    dispatch(resetVendorState());
    dispatch(getVendor());
  };

  const handleGetTransactionTax = (companyId) => {
    dispatch(resetTransactionTaxState());
    dispatch(getTransactionTax({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    setPurchase(purchaseAdded);
  }, [purchaseAdded]);

  useEffect(() => {
    if (!isEmpty(purchaseAdded)) {
      setPurchase(purchaseAdded);
    }
  }, [purchaseAdded]);

  useEffect(() => {
    if (!isEmpty(purchases)) {
      let filteredPurchases = purchases;
      if (activeTypeTab !== "all") {
        filteredPurchases = purchases.filter((purchase) => purchase.purchase_status.name === activeTypeTab);
      }
      setPurchaseList(filteredPurchases.map((el) => ({ ...el, isChecked: false })));
      setInfo(purchases[purchases.length - 1]);
    }
  }, [purchases]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var materialVarianData = [];
      var opt_material = [];
      productVarians.forEach((item, key) => {
        const varian = item.pvar_product ? item.pvar_product : "";
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });
        if (item.typeId === 3) {
          opt_material.push({ label: varian.name, name: varian.name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId });
        }
      });

      var option_material = { options: opt_material.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      materialVarianData.push(option_material);
      setMaterialList(materialVarianData);
    }
  }, [productVarians, branchIdSelected]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {}, []);

  const handleBeforePrint = useCallback(() => {}, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(paymentTerms)) {
      var data = [];
      var opt = [];
      paymentTerms.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentTermList(data);
    }
  }, [paymentTerms]);

  useEffect(() => {
    if (!isEmpty(transactionTaxs)) {
      var data = [];
      var opt = [{ label: "Non Pajak", value: 0, amount: 0 }];
      transactionTaxs.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const amount = parseFloat(item.amount) || 0;
        var obj = { label: name, value: id, amount: amount };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTaxList(data);
    }
  }, [transactionTaxs]);

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      var data = [];
      var opt = [];
      shipmentCarriers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setShipmentCarrierList(data);
    }
  }, [shipmentCarriers]);

  useEffect(() => {
    if (!isEmpty(shipmentMethods)) {
      var data = [];
      var opt = [];
      shipmentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setShipmentMethodList(data);
    }
  }, [shipmentMethods]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentMethodList(data);
    }
    else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      var vendorData = [];
      var opt = [];
      vendors.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      vendorData.push(option);
      setVendorList(vendorData);
    }
  }, [vendors]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  const onClickDelete = (purchase) => {
    setPurchase(purchase);
    setDeleteModal(true);
  };

  const handleDeletePurchase = () => {
    if (purchase) {
      dispatch(onDeletePurchase(purchase));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPurchase(null);
      setPurDocImg([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setPurchase(null);
      setPurDocImg([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  const handlePurchaseClick = useCallback(
    (arg, type) => {
      const data = arg;
      let purchaseDetail = [];

      if (data.purchase_detail) {
        data.purchase_detail.forEach((element) => {
          purchaseDetail.push({
            detailId: element.id,
            itemId: element.productVarianId,
            account: {
              label: element.cvl_account,
              value: element.civilAccountId,
            },
            item: { label: `${element.name} - ${element.barcode}`, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, amount: element.amount, brandId: element.brandId, productId: element.productId },
            amount: parseFloat(element.amount),
            quantity: parseFloat(element.quantity),
            total: parseFloat(element.amount_total),
            name: element.name,
            cvl_account: element.cvl_account,
            sku: element.sku,
            barcode: element.barcode,
            disable: element.civilAccountId ? true : false,
            brandId: element.brandId,
            civilAccountId: element.civilAccountId,
            accepted: element.accepted ? parseFloat(element.accepted) : 0,
            rejected: element.rejected ? parseFloat(element.rejected) : 0,
          });
        });
      }

      let files = [];
      for (const f of data.purchase_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setPurDocImg(files);
      setPurchase({
        id: data.id,
        statusId: data.statusId,
        transaction_no: data.transaction_no,
        transaction_reff: data.transaction_reff,
        description: data.description,
        transactionat: data.transactionat,
        dueat: data.dueat,
        type: data.type && { label: data.type, value: data.type },
        company: data.purchase_company && data.purchase_company.name && { label: data.purchase_company.name, value: data.purchase_company.id },
        tax: data.purchase_tax && {
          label: data.purchase_tax.name,
          value: data.purchase_tax.id,
          amount: parseFloat(data.purchase_tax.amount),
        },
        branch: data.purchase_branch && {
          label: data.purchase_branch.name,
          value: data.purchase_branch.id,
        },
        client: data.purchase_client && {
          label: data.purchase_client.name,
          value: data.purchase_client.id,
        },
        shipmentCarrier: data.purchase_shipment_carrier && {
          label: data.purchase_shipment_carrier.name,
          value: data.purchase_shipment_carrier.id,
        },
        shipmentMethod: data.purchase_shipment_method && {
          label: data.purchase_shipment_method.name,
          value: data.purchase_shipment_method.id,
        },
        paymentMethod: data.purchase_pm && {
          label: data.purchase_pm.name,
          value: data.purchase_pm.id,
        },
        paymentTerm: data.purchase_payment_term && {
          label: data.purchase_payment_term.name,
          value: data.purchase_payment_term.id,
        },
        department: data.purchase_department && {
          label: data.purchase_department.name,
          value: data.purchase_department.id,
        },
        vendor: data.purchase_vendor && {
          label: data.purchase_vendor.name,
          value: data.purchase_vendor.id,
        },
        purchase_history: data.purchase_history,
        purchase_approvedby: data.purchase_approvedby && {
          label: data.purchase_approvedby.name,
          value: data.purchase_approvedby.id,
        },
        purchase_createdby: data.purchase_createdby && {
          label: data.purchase_createdby.name,
          value: data.purchase_createdby.id,
        },
        status: data.purchase_status && { label: data.purchase_status.name, value: data.purchase_status.id },
        total_amount: data.total_amount ? parseFloat(data.total_amount) : 0,
        sub_amount: data.sub_amount ? parseFloat(data.sub_amount) : 0,
        tax_percentage: data.tax_percentage ? parseFloat(data.tax_percentage) : 0,
        tax_amount: data.tax_amount ? parseFloat(data.tax_amount) : 0,
        down_payment: data.down_payment ? parseFloat(data.down_payment) : 0,
        shipment_amount: data.shipment_amount ? parseFloat(data.shipment_amount) : 0,
        disc_amount: data.disc_amount ? parseFloat(data.disc_amount) : 0,
        items: purchaseDetail,
      });

      setIsEdit(true);
      switch (type) {
        case "detail":
          toggleDetail();
          break;
        default:
          setIsEdit(true);
          toggle();
          break;
      }
    },
    [toggle]
  );

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = purchaseList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPurchaseList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = purchaseList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setPurchaseList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      handlePurchaseClick(data, "detail");
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      toggleHistory();
                    }}
                  >
                    <i className=" ri-history-line fs-15"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <>
                      <Button
                        color="light"
                        className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePurchaseGeneral") !== -1 ? "btn-sm" : "btn-sm d-none"}
                        onClick={() => {
                          setSubmitType("save");
                          handlePurchaseClick(data);
                        }}
                      >
                        <i className="ri-edit-2-line fs-15"></i>
                      </Button>
                      <Button
                        color="light"
                        className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePurchaseGeneral") !== -1 ? "btn-sm" : "btn-sm d-none"}
                        onClick={() => {
                          onClickDelete(data);
                        }}
                      >
                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                      </Button>
                    </>
                  )}
                  <DropdownToggle tag="button" className={data.statusId === 5 || data.statusId === 6 || data.statusId === 7 ? "d-none" : userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("processPurchaseGeneral") !== -1 ? "btn btn-sm btn-light" : "d-none"} split></DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={() => {
                        data.actionTitle = `Anda Akan Menandai Transaksi Pembelian ke ${data.purchase_vendor.name} #${data.code} Sudah Selesai`;
                        data.statusPurchaseId = 5;
                        setPurchase(data);
                        toggleApprove();
                      }}
                    >
                      COMPLETED
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        data.actionTitle = `Anda Akan Membatalkan Transaksi Pembelian Ke  ${data.purchase_vendor.name}  #${data.code} `;
                        data.statusPurchaseId = 6;
                        setPurchase(data);
                        toggleApprove();
                      }}
                    >
                      CANCELED
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        data.actionTitle = `Anda Akan Meretur Transaksi Pembelian Ke ${data.purchase_vendor.name} #${data.code}`;
                        data.statusPurchaseId = 7;
                        setPurchase(data);
                        toggleApprove();
                      }}
                    >
                      RETURNED
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {data.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" ? "btn btn-sm btn-soft-success" : userRole && userRole.split(",").indexOf("approvePurchaseGeneral") !== -1 ? "btn btn-sm btn-soft-success" : "btn btn-sm btn-soft-success d-none"}
                  onClick={() => {
                    data.actionTitle = `Anda Akan APPROVE Data Permintaan Pembelian ke ${data.purchase_vendor.name}`;
                    data.statusPurchaseId = 2;
                    setPurchase(data);
                    toggleApprove();
                  }}
                >
                  <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                </button>
              )}
              {data.statusId === 2 && (
                <button
                  className={userType === "admin" || userType === "client" ? "btn btn-sm btn-soft-success" : userRole && userRole.split(",").indexOf("processPurchaseGeneral") !== -1 ? "btn btn-sm btn-soft-success" : "btn btn-sm btn-soft-success d-none"}
                  onClick={() => {
                    setSubmitType("process");
                    handlePurchaseClick(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>PROCESS
                </button>
              )}
              {!data.hasPaid && data.statusId > 2 && data.statusId < 6 && (
                <button
                  className={userType === "admin" || userType === "client" ? "btn btn-sm btn-soft-success" : userRole && userRole.split(",").indexOf("processPurchaseGeneral") !== -1 ? "btn btn-sm btn-soft-success" : "btn btn-sm btn-soft-success d-none"}
                  onClick={() => {
                    setInfo(data);
                    toggleAccPayment();
                  }}
                >
                  <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>PEMBAYARAN
                </button>
              )}
            </div>
          );
        },
        id: "#",
      },
      {
        Header: "No Transaksi",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <Link
              to="#"
              className="fw-semibold text-dark"
              onClick={() => {
                handlePurchaseClick(data, "detail");
              }}
            >
              {data.transaction_no}
            </Link>
          );
        },
      },
      {
        Header: "Proyek",
        accessor: "purchase_branch.branch_code",
        filterable: true,
      },
      {
        Header: "Suplier",
        accessor: "purchase_vendor.name",
        filterable: true,
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "transactionat",
        filterable: false,
        Cell: (data) => {
          return handleValidDate(data.row.original.transactionat);
        },
      },
      {
        Header: "JatuhTempo",
        accessor: "dueat",
        filterable: false,
        Cell: (data) => {
          return handleValidDate(data.row.original.dueat);
        },
      },
      {
        Header: "Jumlah",
        accessor: "sub_amount",
        filterable: true,
        Cell: (data) => {
          let qty = 0;
          data.row.original.purchase_detail.forEach((element) => {
            qty += parseFloat(element.quantity);
          });
          return <span className="fw-semibold">{currencyFormat(qty)}</span>;
        },
      },
      {
        Header: "Total",
        accessor: "total_amount",
        filterable: true,
        Cell: (data) => {
          return <span className="fw-semibold">{currencyFormat(data.row.original.total_amount === null ? 0 : data.row.original.total_amount)}</span>;
        },
      },
      {
        Header: "Uang Muka",
        accessor: "down_payment",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.down_payment === null ? 0 : data.row.original.down_payment)}</span>;
        },
      },
      {
        Header: "Total Terbayar",
        accessor: "paid_amount",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.paid_amount === null ? 0 : data.row.original.paid_amount)}</span>;
        },
      },
      // {
      //   Header: "Down Payment",
      //   accessor: "down_payment",
      //   filterable: true,
      //   Cell: (data) => {
      //     return <span>{currencyFormat(data.row.original.down_payment === null ? 0 : data.row.original.down_payment)}</span>;
      //   },
      // },
      {
        Header: "Status",
        accessor: "purchase_status.name",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          let stat;
          let statName = data.purchase_status && data.purchase_status.name;
          switch (statName) {
            case "DRAFT":
              stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
              break;
            case "CONFIRMED":
              stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
              break;
            case "PROCESSED":
              stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
              break;
            case "RECEIVED":
              stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
              break;
            case "COMPLETED":
              stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
              break;
            default:
              stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
              break;
          }

          return (
            <div className="hstack gap-2">
              {stat}
              {data.hasPaid ? <span className="badge text-uppercase badge-soft-info">Paid</span> : <span className="badge text-uppercase badge-soft-warning">Unpaid</span>}
            </div>
          );
        },
      },
    ],
    [purchaseList, handlePurchaseClick, toggleApprove, toggleHistory, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = purchaseList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPurchaseList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => purchaseList, [purchaseList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: (info && info.total_amount - info.paid_amount) || 0,
      account: "",
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      account: Yup.object().required("Please enter payment account").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPurchaseLoading());
      if (info) {
        info.setAccPayment = true;
        info.setApprove = false;
        info.accPaymentId = values.account.value;
        info.transactionat = values.transactionat;
        info.accType = "PAYABLE";
        info.description = `PEMBAYARAN INVOICE (${info.purchase_vendor.name} #${info.code})`;
        info.amount = values.amount;
        dispatch(onUpdatePurchase(info));
      }
      validationAccPayment.resetForm();
      toggleAccPayment();
    },
  });

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (purchase) {
        purchase.setApprove = true;
        purchase.approval_note = values.approval_note;
        dispatch(onUpdatePurchase(purchase));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (purchase && purchase.id) || 0,
      client: (purchase && purchase.client) || clientSelected,
      company: (purchase && purchase.company) || companySelected,
      unit: (purchase && purchase.unit) ?? "",
      transaction_reff: (purchase && purchase.transaction_reff) ?? "",
      branch: (purchase && purchase.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      department: (purchase && purchase.department) || departmentSelect,
      shipmentCarrier: (purchase && purchase.shipmentCarrier) ?? "",
      shipmentMethod: (purchase && purchase.shipmentMethod) ?? "",
      paymentMethod: (purchase && purchase.paymentMethod) ?? "",
      paymentTerm: (purchase && purchase.paymentTerm) ?? "",
      transactionat: (purchase && purchase.transactionat) ?? "",
      dueat: (purchase && purchase.dueat) ?? "",
      description: (purchase && purchase.description) ?? "",
      vendor: (purchase && purchase.vendor) ?? "",
      disc_amount: (purchase && purchase.disc_amount) || 0,
      tax: (purchase && purchase.tax) ?? "",
      tax_percentage: (purchase && purchase.tax_percentage) || 0,
      tax_amount: (purchase && purchase.tax_amount) || 0,
      total_amount: (purchase && purchase.total_amount) || 0,
      sub_amount: (purchase && purchase.sub_amount) || 0,
      shipment_amount: (purchase && purchase.shipment_amount) || 0,
      down_payment: (purchase && purchase.down_payment) || 0,
      items: (purchase && purchase.items) || [],
    },
    validationSchema: Yup.object({
      paymentMethod: Yup.object().required("Please Select Payment Method").nullable(true),
      transactionat: Yup.string().required("Please enter transaction date"),
      branch: Yup.object().required("Please Select Warehouse").nullable(true),
      department: Yup.object().required("Please Select Department").nullable(true),
      vendor: Yup.object().required("Please Select Vendor").nullable(true),
      company: Yup.object().required("Please Select company").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPurchaseLoading());
      if (isEdit) {
        let editSubmit = {
          id: values.id,
          typeId: 2,
          transaction_reff: values.transaction_reff,
          description: values.description,
          transactionat: values.transactionat,
          dueat: values.dueat,
          shipmentCarrierId: values.shipmentCarrier.value,
          shipmentMethodId: values.shipmentMethod.value,
          shipment_amount: values.shipment_amount,
          paymentMethodId: values.paymentMethod.value,
          paymentTermId: values.paymentTerm.value,
          taxId: values.tax.value === 0 ? null : values.tax.value,
          tax_percentage: values.tax_percentage,
          statusPurchaseId: 2,
          clientId: values.client.value,
          departmentId: values.department.value,
          branchId: values.branch.value,
          vendorId: values.vendor.value,
          companyId: values.company.value,
          disc_amount: values.disc_amount,
          total_amount: values.total_amount,
          tax_amount: values.tax_amount,
          sub_amount: values.sub_amount,
          down_payment: values.down_payment,
          purchase_detail: JSON.stringify(values.items),
          files: purDocImg.length > 0 ? purDocImg : [],
        };

        if (submitType === "process") {
          editSubmit.statusPurchaseId = 3;
        }

        if (submitType === "save") {
          editSubmit.statusPurchaseId = 1;
        }

        dispatch(onUpdatePurchase(editSubmit));
      } else {
        let addSubmit = {
          typeId: 2,
          transaction_reff: values.transaction_reff,
          description: values.description,
          transactionat: values.transactionat,
          dueat: values.dueat,
          branchId: values.branch.value,
          shipmentCarrierId: values.shipmentCarrier.value,
          shipmentMethodId: values.shipmentMethod.value,
          shipment_amount: values.shipment_amount,
          paymentMethodId: values.paymentMethod.value,
          paymentTermId: values.paymentTerm.value,
          taxId: values.tax.value === 0 ? null : values.tax.value,
          tax_percentage: values.tax_percentage,
          statusPurchaseId: 1,
          clientId: values.client.value,
          departmentId: values.department.value,
          vendorId: values.vendor.value,
          companyId: values.company.value,
          disc_amount: values.disc_amount,
          total_amount: values.total_amount,
          tax_amount: values.tax_amount,
          sub_amount: values.sub_amount,
          down_payment: values.down_payment,
          purchase_detail: JSON.stringify(values.items),
          files: purDocImg.length > 0 ? purDocImg : [],
        };

        dispatch(onAddNewPurchase(addSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  const handlePurchaseDetailAdd = () => {
    validation.setFieldValue("items", [
      ...validation.values.items,
      {
        detailId: 0,
        itemId: 0,
        item: {
          label: "Pilih Produk",
          value: 0,
          name: "Pilih Produk",
          sku: "",
          barcode: "",
          amount: 0,
          brandId: 0,
          productId: 0,
        },
        account: {
          label: "Pilih Item Anggaran",
          value: 0,
        },
        amount: 0,
        civilAccountId: 0,
        quantity: 0,
        total: 0,
        name: "",
        cvl_account: "",
        sku: "",
        barcode: "",
        brandId: 0,
        accepted: 0,
        rejected: 0,
      },
    ]);
    handleTotal();
  };

  const onClickDeleteDetailItem = (index) => {
    validation.values.items.splice(index, 1);
    handleTotal();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = purDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setPurDocImg(newState);
    } else {
      const index = purDocImg.findIndex((fl) => fl.filename === file.filename);
      setPurDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };
  const handleSelectFile = (file) => {
    setPurDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleTotal = () => {
    let sub_amount = 0;
    for (const item of validation.values.items) {
      sub_amount += parseFloat(item.quantity * item.amount);
    }
    let sub_total_net = sub_amount - validation.values.disc_amount;
    let tax_amount = (validation.values.tax_percentage / 100) * sub_total_net;
    let total_amount = sub_total_net + tax_amount + validation.values.shipment_amount;

    validation.setFieldValue("tax_amount", parseFloat(tax_amount));
    validation.setFieldValue("total_amount", parseFloat(total_amount));
    validation.setFieldValue("sub_amount", parseFloat(sub_amount));
  };

  const handlePriceDetail = (e, i) => {
    let val = parseFloat(e.target.value);
    if (!isNaN(val)) {
      validation.values.items[i].amount = val;
      validation.values.items[i].total = validation.values.items[i].quantity * val;
    } else {
      validation.values.items[i].amount = 0;
      validation.values.items[i].total = validation.values.items[i].quantity * 0;
    }
    handleTotal();
  };

  const handleBtnQtyDetail = (type, i) => {
    if (type === "add") {
      let valReduce = validation.values.items[i].quantity + 1;
      validation.values.items[i].quantity = valReduce;
      validation.values.items[i].total = validation.values.items[i].amount * valReduce;
      handleTotal();
    } else if (type === "reduce") {
      let valAdd = validation.values.items[i].quantity > 0 ? validation.values.items[i].quantity - 1 : validation.values.items[i].quantity;
      validation.values.items[i].quantity = valAdd;
      validation.values.items[i].total = validation.values.items[i].amount * valAdd;
      handleTotal();
    }
  };

  const handleQuantityDetail = (e, i) => {
    let val = e.target.value;
    if (!isNaN(val)) {
      validation.values.items[i].quantity = val;
      validation.values.items[i].total = validation.values.items[i].amount * val;
    } else {
      validation.values.items[i].quantity = 0;
      validation.values.items[i].total = validation.values.items[i].amount * 0;
    }
    handleTotal();
  };

  const handleShipmentChange = (e) => {
    let val = parseFloat(e.target.value);
    if (!isNaN(val)) {
      validation.setFieldValue("shipment_amount", val);
    } else {
      validation.setFieldValue("shipment_amount", 0);
    }
  };

  const handleDiskonChange = (e) => {
    let val = parseFloat(e.target.value);
    if (!isNaN(val)) {
      validation.setFieldValue("disc_amount", val);
    } else {
      validation.setFieldValue("disc_amount", 0);
    }
  };

  const handleTaxChange = (e) => {
    let val = parseFloat(e.amount);
    if (!isNaN(val)) {
      validation.setFieldValue("tax_percentage", val);
      let sub_amount = 0;
      for (const item of validation.values.items) {
        sub_amount += parseFloat(item.quantity * item.amount);
      }
      let sub_total_net = sub_amount - validation.values.disc_amount;
      let tax_amount = (val / 100) * sub_total_net;
      let total_amount = sub_total_net + tax_amount + validation.values.shipment_amount;

      validation.setFieldValue("tax_amount", parseFloat(tax_amount));
      validation.setFieldValue("total_amount", parseFloat(total_amount));
      validation.setFieldValue("sub_amount", parseFloat(sub_amount));
    } else {
      validation.setFieldValue("tax_percentage", 0);
    }
    validation.setFieldValue("tax", e);
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePurchase(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    if (filterDate) {
      let datearr = filterDate?.split(" to ");
      if (datearr) {
        startat = datearr[0];
        endat = datearr[1] ? datearr[1] : datearr[0];
      }
    }

    var status = statusPurchase.value ? statusPurchase.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: branchIdSelected?.value ?? "",
      typeId: 2,
    };
    dispatch(onGetPurchases(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPurchaseList([]);
    setStatusPurchase([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    handleGetPurchase(companySelected?.value ?? "", branchSelected?.value ?? "");
  };

  useEffect(() => {
    if (branchSelected) {
      handleGetPurchase(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, branchSelected]);

  document.title = "Permintaan Pembelian | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={purchaseList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePurchase} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Pengadaan Barang" pageTitle="Transaksi Pembelian">
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPurchaseGeneral") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                setSubmitType("save");
                validation.resetForm();
                toggle();
              }}
            >
              <i className="ri-add-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={purchaseDoc} />
            {/* <button type="button"  className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>  */}
            {/* <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-bank-card-2-line me-1 align-bottom fs-15"></i> SEMUA TRANSAKSI
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "CONFIRMED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> CONFIRMED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "PROCESSED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> PROCESSED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("5", "RECEIVED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RECEIVED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "6" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("6", "COMPLETED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "7" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("7", "RETURNED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RETURNED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "8" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("8", "CANCELED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> CANCELED
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        {/* <Col sm={3}>
                          <Select
                            name="searchBranch"
                            value={searchBranch}
                            placeholder="Filter Proyek"
                            onChange={(e) => {
                              setSearchBranch(e);
                              handleGetPurchase(e.companyId, e.value);
                            }}
                            options={branchList}
                          ></Select>
                        </Col> */}
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Permintaan Pembelian" : "Tambah Permintaan Pembelian"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className="border-bottom border-bottom-dashed p-2">
                        <Row>
                          <Col lg={6}>
                            <div className="profile-user mx-auto  mb-3">
                              <Input id="profile-img-file-input" type="file" className="profile-img-file-input" />
                              <Label for="profile-img-file-input" className="d-block">
                                <span className="overflow-hidden border border-dashed d-flex align-items-center justify-content-center rounded" style={{ height: "60px", width: "256px" }}>
                                  <img src={logoDark} className="card-logo card-logo-dark user-profile-image img-fluid" alt="logo dark" />
                                  <img src={logoLight} className="card-logo card-logo-light user-profile-image img-fluid" alt="logo light" />
                                </span>
                              </Label>
                            </div>
                            <div>
                              <Row>
                                <Col lg={7} sm={7}>
                                  <div className="mb-3">
                                    <Select
                                      name="branch"
                                      placeholder="Pilih Cabang / Proyek Penerima"
                                      value={validation.values.branch}
                                      isDisabled={branchList.length > 0 ? false : true}
                                      onChange={(e) => {
                                        validation.setFieldValue("branch", e);
                                        setBranchIdSelected(e.value);
                                      }}
                                      options={branchList}
                                    ></Select>
                                    {validation.touched.branch && validation.errors.branch && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.branch}
                                      </small>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={5} sm={5}>
                                  <div className="mb-3">
                                    <Select
                                      name="vendor"
                                      value={validation.values.vendor}
                                      placeholder="Pilih Supplier"
                                      onChange={(e) => {
                                        validation.setFieldValue("vendor", e);
                                      }}
                                      options={vendorList}
                                    ></Select>
                                    {validation.touched.vendor && validation.errors.vendor && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validation.errors.vendor}
                                      </p>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={6} sm={6} className="d-none mb-3">
                                  <div className="mb-3">
                                    <Select
                                      name="shipmentMethod"
                                      placeholder="Metode Kirim"
                                      value={validation.values.shipmentMethod}
                                      onChange={(e) => {
                                        validation.setFieldValue("shipmentMethod", e);
                                      }}
                                      options={shipmentMethodList}
                                    ></Select>
                                    {validation.touched.shipmentMethod && validation.errors.shipmentMethod && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.shipmentMethod}
                                      </small>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={7} sm={7}>
                                  <div className="mb-3">
                                    <Select
                                      name="shipmentCarrier"
                                      placeholder="Kurir"
                                      value={validation.values.shipmentCarrier}
                                      onChange={(e) => {
                                        validation.setFieldValue("shipmentCarrier", e);
                                      }}
                                      options={shipmentCarrierList}
                                    ></Select>
                                    {validation.touched.shipmentCarrier && validation.errors.shipmentCarrier && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.shipmentCarrier}
                                      </small>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={5} sm={5}>
                                  <div className="mb-3">
                                    <Flatpickr
                                      className="form-control"
                                      id="datepicker-publish-input"
                                      placeholder="Tgl Pembelian"
                                      options={{
                                        mode: "single",
                                        dateFormat: "Y/m/d",
                                      }}
                                      onChange={(selectedDates, dateStr) => {
                                        validation.setFieldValue("transactionat", dateStr);
                                      }}
                                      value={validation.values.transactionat}
                                    />
                                    {validation.touched.transactionat && validation.errors.transactionat && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validation.errors.transactionat}
                                      </p>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="client"
                                  value={validation.values.client}
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  placeholder="Pilih Grup Usaha"
                                  onChange={(e) => {
                                    dispatch(setCompanySelect(e));
                                    setCompanyList([]);
                                    setDepartmentList([]);
                                    setVendorList([]);
                                    setBranchList([]);
                                    validation.setFieldValue("company", "");
                                    validation.setFieldValue("department", "");
                                    validation.setFieldValue("vendor", "");
                                    validation.setFieldValue("branch", "");
                                    validation.setFieldValue("client", e);
                                  }}
                                  options={clientList}
                                ></Select>
                                <div
                                  className="position-absolute"
                                  style={{
                                    top: "12px",
                                    left: "-24px",
                                  }}
                                >
                                  {clientLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.client && validation.errors.client ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.client}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="company"
                                  value={validation.values.company}
                                  placeholder="Pilih Perusahaan"
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  onChange={(e) => {
                                    dispatch(setCompanySelect(e));
                                    validation.resetForm();
                                    validation.setFieldValue("company", e);
                                    handleGetPurchase(e.value, branchSelected.value);
                                    setDepartmentList([]);
                                    setVendorList([]);
                                    setBranchList([]);
                                    setPaymentTermList([]);
                                    setPaymentMethodList([]);
                                    setShipmentCarrierList([]);
                                    setShipmentMethodList([]);
                                    setAccountingList([]);
                                  }}
                                  options={companyList}
                                ></Select>
                                <div
                                  className="position-absolute"
                                  style={{
                                    top: "12px",
                                    left: "-24px",
                                  }}
                                >
                                  {companyLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.company && validation.errors.company ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.company}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="department"
                                  value={validation.values.department}
                                  placeholder="Pilih Departemen"
                                  onChange={(e) => {
                                    validation.setFieldValue("department", e);
                                  }}
                                  options={departmentList}
                                ></Select>
                                <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                  {departmentLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.department && validation.errors.department && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.department}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <Input value={validation.values.transaction_reff} name="transaction_reff" id="transaction_reff" className="form-control" placeholder="No Referensi" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="p-4 border-top border-top-dashed position-relative">
                        {(clientLoading || companyLoading || productVarianLoading) && (
                          <div className="position-absolute top-0">
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </div>
                        )}
                        <div className="mb-0">
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>
                                  #
                                </th>
                                <th scope="col">Produk</th>
                                <th scope="col" style={{ width: "120px" }}>
                                  Harga
                                </th>
                                <th scope="col" style={{ width: "90px" }}>
                                  Jumlah
                                </th>
                                <th scope="col" className="text-end" style={{ width: "120px" }}>
                                  Total
                                </th>
                                <th scope="col" className="text-end" style={{ width: "35px" }}></th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {validation.values.items &&
                                validation.values.items.map((o, i) => {
                                  return (
                                    <tr key={"purchaseDetailItem-" + i} className="product">
                                      <th scope="row" className="product-id">
                                        {i + 1}
                                      </th>
                                      <td className="text-start">
                                        <div>
                                          <Select
                                            name="item"
                                            isDisabled={validation.values.items[i].disable}
                                            value={validation.values && validation.values.items ? validation.values.items[i].item : {}}
                                            placeholder="Pilih Produk"
                                            onChange={(e) => {
                                              validation.values.items[i].item = e;
                                              validation.values.items[i].sku = e.sku;
                                              validation.values.items[i].barcode = e.barcode;
                                              validation.values.items[i].itemId = e.value;
                                              validation.values.items[i].brandId = e.brandId;
                                              validation.values.items[i].amount = parseFloat(e.price);
                                              validation.values.items[i].quantity = 1;
                                              handleTotal();
                                            }}
                                            options={materialList}
                                          ></Select>
                                        </div>
                                      </td>
                                      <td>
                                        <Input
                                          name="amount"
                                          placeholder="amount"
                                          type="number"
                                          className="form-control product-price"
                                          onFocus={(e) => e.target.select()}
                                          style={{ width: "140px" }}
                                          value={validation.values && validation.values.items ? validation.values.items[i].amount : 0}
                                          onChange={(e) => {
                                            handlePriceDetail(e, i);
                                          }}
                                          onBlur={validation.handleBlur}
                                        />
                                      </td>
                                      <td>
                                        <div className="input-step">
                                          <button
                                            disabled={validation.values.items[i].disable}
                                            type="button"
                                            className="minus"
                                            onClick={() => {
                                              handleBtnQtyDetail("reduce", i);
                                            }}
                                          >
                                            –
                                          </button>
                                          <Input
                                            name="quantity"
                                            disabled={validation.values.items[i].disable}
                                            placeholder="Qty"
                                            type="text"
                                            className="product-quantity border-0"
                                            style={{ width: "100px" }}
                                            onFocus={(e) => e.target.select()}
                                            value={validation.values && validation.values.items ? validation.values.items[i].quantity : 0}
                                            onChange={(e) => {
                                              handleQuantityDetail(e, i);
                                            }}
                                            onBlur={validation.handleBlur}
                                          />
                                          <button
                                            type="button"
                                            disabled={validation.values.items[i].disable}
                                            className="plus"
                                            onClick={() => {
                                              handleBtnQtyDetail("add", i);
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </td>
                                      <td className="text-end">
                                        <div>
                                          <Input name="total" placeholder="Total" type="text" className="form-control product-line-price bg-light border-0" style={{ width: "180px" }} disabled value={validation.values && validation.values.items ? validation.values.items[i].amount * validation.values.items[i].quantity : 0} onChange={(e) => {}} onBlur={validation.handleBlur} />
                                        </div>
                                      </td>
                                      <td className="product-removal">
                                        <Link
                                          to="#"
                                          className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                          onClick={() => {
                                            onClickDeleteDetailItem(i);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                            <tbody>
                              <tr>
                                <td className="10">
                                  {validation.touched.items && validation.errors.items && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.items}
                                    </small>
                                  )}
                                </td>
                              </tr>
                              <tr id="newForm" style={{ display: "none" }}>
                                <td className="d-none" colSpan="5">
                                  <p>Tambah Form</p>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="3" style={{ verticalAlign: "middle", paddingBottom: "30px" }} className="">
                                  <Link
                                    to="#"
                                    className="btn btn-soft-success fw-medium"
                                    id="add-item"
                                    onClick={() => {
                                      handlePurchaseDetailAdd();
                                    }}
                                  >
                                    <i className="ri-add-fill me-1 align-bottom"></i>Tambah Item
                                  </Link>
                                </td>
                                <td style={{ verticalAlign: "middle", paddingBottom: "30px" }} className="fw-semibold text-end"></td>
                                <td colSpan="2" style={{ verticalAlign: "middle", paddingBottom: "30px" }}></td>
                              </tr>
                              <tr className="border-top border-top-dashed mt-4">
                                <td colSpan="2">
                                  <div className="mb-3">
                                    <Select
                                      name="paymentMethod"
                                      value={validation.values.paymentMethod}
                                      placeholder="Pilih Jenis Transaksi"
                                      onChange={(e) => {
                                        validation.setFieldValue("paymentMethod", e);
                                      }}
                                      options={paymentMethodList}
                                    ></Select>
                                    {validation.touched.paymentMethod && validation.errors.paymentMethod && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.paymentMethod}
                                      </small>
                                    )}
                                  </div>
                                  <Row>
                                    <div className="mb-3 col-lg-7">
                                      <Select
                                        name="paymentTerm"
                                        value={validation.values.paymentTerm}
                                        placeholder="Pilih Tempo Pembayaran"
                                        onChange={(e) => {
                                          validation.setFieldValue("paymentTerm", e);
                                          var new_date = moment(validation.values.transactionat, "YYYY/MM/DD").add(e.amount, "days");
                                          validation.setFieldValue("dueat", new_date.format("YYYY/MM/DD"));
                                        }}
                                        options={paymentTermList}
                                      ></Select>
                                    </div>
                                    <div className="mb-3 col-lg-5">
                                      <Flatpickr
                                        className="form-control"
                                        id="datepicker-publish-input"
                                        placeholder="Tgl Jatuh Tempo"
                                        options={{
                                          mode: "single",
                                          dateFormat: "Y/m/d",
                                        }}
                                        onChange={(selectedDates, dateStr) => {
                                          validation.setFieldValue("dueat", dateStr);
                                        }}
                                        value={validation.values.dueat}
                                      />
                                    </div>
                                  </Row>
                                  <div className="mb-3">
                                    <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={4} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} />
                                  </div>
                                  <div className="mb-3 d-flex justify-content-between">
                                    <Label htmlFor="education" className="form-label">
                                      Dokumen Transaksi
                                    </Label>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-label btn-soft-success"
                                      onClick={() => {
                                        toggleMedia();
                                      }}
                                    >
                                      <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                    </button>
                                  </div>
                                  {purDocImg.map((f, i) => {
                                    if (f.isDeleted) {
                                      return null;
                                    } else {
                                      return (
                                        <div key={i} className="border-bottom mb-3">
                                          <div className="d-flex justify-content-between mb-3 align-items-center">
                                            <div className="me-2">
                                              <img src={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                            </div>
                                            <div className="text-truncate">{f.filename}</div>
                                            <div>
                                              <Link
                                                to="#"
                                                className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                                onClick={(e) => {
                                                  handleDeleteFile(f);
                                                }}
                                              >
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                </td>
                                <td></td>
                                <td></td>
                                <td colSpan="3" className="p-0">
                                  <Table className="table-borderless table-sm table-nowrap align-middle mb-0">
                                    <tbody>
                                      <tr>
                                        <th scope="row">Sub Total</th>
                                        <td style={{ width: "150px" }}>
                                          <Input name="sub_amount" value={validation.values.sub_amount} type="text" className="form-control bg-light border-0" id="cart-subtotal" style={{ width: "180px" }} placeholder="0.00" disabled />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Diskon</th>
                                        <td>
                                          <Input name="disc_amount" id="disc_amount" className="form-control" placeholder="Diskon" type="number" value={validation.values.disc_amount} onChange={(e) => handleDiskonChange(e)} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Uang Muka</th>
                                        <td>
                                          <Input
                                            value={validation.values.down_payment}
                                            name="down_payment"
                                            id="down_payment"
                                            className="form-control"
                                            placeholder="Credit Amount"
                                            type="number"
                                            onFocus={(e) => e.target.select()}
                                            onChange={(e) => {
                                              let val = parseFloat(e.target.value);
                                              if (!isNaN(val)) {
                                                e.target.value = val.toString();
                                                validation.setFieldValue("down_payment", val);
                                              } else {
                                                e.target.value = 0;
                                                validation.setFieldValue("down_payment", 0);
                                              }
                                            }}
                                            onBlur={validation.handleBlur}
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Biaya Pengiriman</th>
                                        <td>
                                          <Input value={validation.values.shipment_amount} name="shipment_amount" id="shipment_amount" className="form-control" placeholder="Shipping Price" type="number" onChange={(e) => handleShipmentChange(e)} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">
                                          <Select name="tax" value={validation.values.tax} placeholder="Tax" onChange={(e) => handleTaxChange(e)} options={taxList}></Select>
                                        </th>
                                        <td>
                                          <Input name="tax_amount" type="text" className="form-control bg-light border-0" id="cart-tax" value={validation.values.tax_amount} style={{ width: "180px" }} placeholder="0" disabled />
                                        </td>
                                      </tr>
                                      <tr className="border-top border-top-dashed d-none">
                                        <th scope="row">Total Amount</th>
                                        <td>
                                          <Input name="total_amount" type="text" className="form-control bg-light border-0" id="cart-total" placeholder="0" value={validation.values.total_amount} style={{ width: "180px" }} disabled />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            validation.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>
                        <button type="submit" className={submitType && (submitType === "save" || submitType === "process") ? "btn btn-success" : "btn btn-success d-none"} disabled={loading}>
                          <span className="d-flex align-items-center">
                            {submitType === "process" ? "PROSES PEMBELIAN" : "SIMPAN DATA PEMBELIAN"} &nbsp;
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalAccPayment" isOpen={modalAccPayment} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleAccPayment}>
                    PEMBAYARAN PEMBELIAN
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationAccPayment.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label">
                            Jumlah
                          </Label>
                          <Input
                            name="amount"
                            id="amount-field"
                            className="form-control"
                            placeholder="Enter amount"
                            type="number"
                            onFocus={(e) => e.target.select()}
                            onChange={(e) => {
                              let paid_amount = !isNaN(parseFloat(info.paid_amount)) ? parseFloat(info.paid_amount) : 0;
                              let total_amount = !isNaN(parseFloat(info.total_amount)) ? parseFloat(info.total_amount) : 0;
                              let left_amount = total_amount - paid_amount;
                              if (!isNaN(parseFloat(e.target.value))) {
                                if (parseFloat(e.target.value) <= left_amount) validationAccPayment.setFieldValue("amount", parseFloat(e.target.value));
                                else validationAccPayment.setFieldValue("amount", left_amount);
                              } else {
                                validationAccPayment.setFieldValue("amount", parseFloat(e.target.value));
                              }
                            }}
                            onBlur={validationAccPayment.handleBlur}
                            value={validationAccPayment.values.amount}
                            invalid={validationAccPayment.touched.amount && validationAccPayment.errors.amount ? true : false}
                          />
                          {validationAccPayment.touched.amount && validationAccPayment.errors.amount ? <FormFeedback type="invalid">{validationAccPayment.errors.amount}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label">
                            Tanggal Pembayaran
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="datepicker-publish-input"
                            placeholder="Select transaction date"
                            options={{
                              mode: "single",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(selectedDates, dateStr) => {
                              validationAccPayment.setFieldValue("transactionat", dateStr);
                            }}
                            value={validationAccPayment.values.transactionat ?? ""}
                          />
                        </div>
                        <div className="mb-3 col-lg-12">
                          <label className="form-label" htmlFor="account">
                            Akun Cash / Bank Pembayaran
                          </label>
                          <Select
                            name="account"
                            value={validationAccPayment.values.account}
                            placeholder="Enter account"
                            onChange={(e) => {
                              validationAccPayment.setFieldValue("account", e);
                            }}
                            options={accountingList}
                          ></Select>
                          {validationAccPayment.touched.account && validationAccPayment.errors.account && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.account}
                            </small>
                          )}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalAccPayment(false);
                            validationAccPayment.resetForm();
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">SIMPAN PEMBAYARAN</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalHistory" isOpen={modalHistory} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleHistory}>
                    Riwayat Pembelian
                  </ModalHeader>
                  <ModalBody>
                    <div className="profile-timeline">
                      <div></div>
                      <div className="accordion accordion-flush" id="todayExample">
                        {info &&
                          info.purchase_history &&
                          info.purchase_history.map((item, i) => {
                            return (
                              <div key={i} className="accordion-item border-0">
                                <div className="accordion-header">
                                  <button className="accordion-button p-2 shadow-none" type="button" id="headingOne">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0">
                                        {item.purchase_history_createdby && item.purchase_history_createdby.employee_image && item.purchase_history_createdby.employee_image.path ? (
                                          <img src={process.env.REACT_APP_API_URL + "/files/" + item.purchase_history_createdby.employee_image.path} alt="" className="rounded-circle avatar-xs" />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item.purchase_history_createdby.name.charAt(0)}</div>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <h6 className="fs-14 mb-1">{item.purchase_history_createdby.name}</h6>
                                        <p className="fw-normal text-muted mb-1">
                                          Memperbarui status pembelian menjadi <span className="fw-semibold text-info">{item.purchase_history_status.name}</span> dengan catatan:
                                        </p>
                                        <p className="fw-normal mb-1">{item.notes || "-"}</p>
                                        <small className="text-muted">
                                          <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat, "YYYY/MM/DD HH:mm:ss").local().fromNow()}
                                        </small>
                                      </div>
                                    </div>
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalHistory(false);
                        }}
                      >
                        Tutup
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    ACTION CONFIRMATION
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="mt-2 text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <p className="fs-16">{purchase && purchase.actionTitle}</p>
                        </div>
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Isi Keterangan (Jika Ada)" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Invoice Detail
                  </ModalHeader>
                  {purchase !== undefined && purchase !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                                <div className="mt-sm-3 mt-3">
                                  <h6 className="text-uppercase fw-semibold">{purchase.client && purchase.client.label}</h6>
                                  <p className="mb-1">{purchase.company && purchase.company.label}</p>
                                </div>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">No Invoice</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{purchase.transaction_no}</span>
                                </h5>
                              </Col>
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">No Rererensi</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{purchase.transaction_reff}</span>
                                </h5>
                              </Col>
                              <Col lg={2} xs={2}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(purchase.transactionat)}</span>
                                </h5>
                              </Col>
                              <Col lg={2} xs={2}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Due Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(purchase.dueat)}</span>
                                </h5>
                              </Col>
                              <Col lg={2} xs={2}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Total</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="total-amount">{currencyFormat(purchase.total_amount)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4">
                            <div>
                              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "50px" }}>
                                      #
                                    </th>
                                    <th scope="col" className="text-start">
                                      Detail Produk
                                    </th>
                                    <th scope="col" className="text-start">
                                      Anggaran
                                    </th>
                                    <th scope="col">Harga</th>
                                    <th scope="col">Jumlah</th>
                                    <th scope="col">Accepted</th>
                                    <th scope="col">Rejected</th>
                                    <th scope="col" className="text-end">
                                      Total
                                    </th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {(purchase.items || []).map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o.name}</td>
                                        <td className="text-start">{o.cvl_account}</td>
                                        <td>Rp{currencyFormat(o.amount)}</td>
                                        <td>{currencyFormat(o.quantity)}</td>
                                        <td>{o.accepted}</td>
                                        <td>{o.rejected}</td>
                                        <td className="text-end">Rp{currencyFormat(o.total)}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                            <div className="border-top border-top-dashed mt-2">
                              <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                                <tbody>
                                  <tr>
                                    <td>Sub Total</td>
                                    <td className="text-end">Rp{currencyFormat(purchase.sub_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Diskon</td>
                                    <td className="text-end">Rp{currencyFormat(purchase.disc_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Biaya Kirim</td>
                                    <td className="text-end">Rp{currencyFormat(purchase.shipment_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Pajak {purchase.tax_percentage} %</td>
                                    <td className="text-end">Rp{currencyFormat(purchase.tax_amount)}</td>
                                  </tr>
                                  <tr className="border-top border-top-dashed fs-15">
                                    <th scope="row">Total</th>
                                    <th className="text-end">Rp{currencyFormat(purchase.total_amount)}</th>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                            <div className="mt-4">
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  <span className="fw-semibold">NOTES:</span>
                                  <span id="note"> {purchase.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="mt-4 row">
                              <div className="col-lg-4">
                                <p className="mb-0 text-center">Bogor, {handleValidDate(purchase.createdat)}</p>
                                <p className="mb-0 text-center">Pengajuan</p>
                                <p className="mb-5 pb-3 fw-semibold text-center">{purchase.purchase_createdby ? purchase.purchase_createdby.label : ""}</p>
                                <p className="mt-5 text-center">................................</p>
                              </div>
                              <div className="col-lg-4">
                                <p className="mb-0 text-center">{purchase.approvedat && handleValidDate(purchase.approvedat)}</p>
                                <p className="mb-0 text-center">Disetujui Oleh</p>
                                <p className="mb-5 pb-3 fw-semibold text-center">{purchase.purchase_approvedby ? purchase.purchase_approvedby.label : ""}</p>
                                <p className="mt-5 text-center">................................</p>
                              </div>
                              {purchase.purchase_history &&
                                purchase.purchase_history.map((o, i) => {
                                  if (o.statusId === 3)
                                    return (
                                      <div className="col-lg-4" key={i}>
                                        <p className="mb-0 text-center">&nbsp;</p>
                                        <p className="mb-0 text-center">Mengetahui</p>
                                        <p className="mb-5 pb-3 fw-semibold text-center">{o.purchase_history_createdby ? o.purchase_history_createdby.name : ""}</p>
                                        <p className="mt-5 text-center">................................</p>
                                      </div>
                                    );
                                  else return null;
                                })}
                            </div>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleDetail();
                        }}
                      >
                        Tutup
                      </button>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={purchase} />
      </Container>
    </div>
  );
};

export default Purchase;
